import { gql } from '@apollo/client';

export const CREATE_AGENT_CONFIG = gql`
  mutation create_agent_config($data: AgentConfigInputType) {
    create_agent_config(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_AGENT_CONFIG = gql`
  query get_agent_config($data: GetAgentConfigInputType) {
    get_agent_config(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_ADVANCE_SETTINGS = gql`
  query get_advance_settings($data: GetAdvanceSettingsInputType) {
    get_advance_settings(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_AGENT_TRAINING_DATA = gql`
  query get_agent_training_data($data: GetAgentTrainingDataInputType) {
    get_agent_training_data(data: $data) {
      hasError
      message
      data {
        agent {
          _id
          name
          business_id
          evergreen_mode
          manual_mode
          created_at
          configuration
        }
        memories {
          _id
          agent_id
          content {
            text
            media {
              type
              url
              metadata {
                _id
                name
                mimetype
                size
                description
                agent_id
                owner_id
              }
            }
          }
          created_at
          updated_at
          embedding
          metadata {
            tags
            source
            source_id
            source_name
            source_type
            source_url
          }
          score
        }
        totalMemories
        hasMore
        pagination {
          limit
          offset
          total
        }
      }
    }
  }
`;

export const GET_AGENT_SETTINGS = gql`
  query get_agent_training_data($data: GetAgentTrainingDataInputType) {
    get_agent_training_data(data: $data) {
      hasError
      message
      data {
        agent {
          _id
          name
          business_id
          evergreen_mode
          manual_mode
          created_at
          configuration
        }
        memories {
          _id
          agent_id
          content {
            text
            media {
              type
              url
              metadata {
                _id
                name
                mimetype
                size
                description
                agent_id
                owner_id
              }
            }
          }
          created_at
          updated_at
          embedding
          metadata {
            tags
            source
            source_id
            source_name
            source_type
            source_url
          }
          score
        }
        totalMemories
        hasMore
        pagination {
          limit
          offset
          total
        }
      }
    }
  }
`;

export const UPDATE_AGENT_PROMPTS = gql`
  mutation update_agent_prompts($data: UpdateAgentPromptsInputType) {
    update_agent_prompts(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_AGENT_BASIC_SETTINGS = gql`
  mutation update_agent_prompts($data: UpdateAgentPromptsInputType) {
    update_agent_prompts(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_AGENT_CONFIG = gql`
  mutation update_agent_config($data: UpdateAgentConfigInputType) {
    update_agent_config(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_AGENT_IN_PROGRESS = gql`
  query get_agent_in_progress {
    get_agent_in_progress {
      hasError
      data
      message
    }
  }
`;

export const CREATE_CHANNEL = gql`
  mutation create_channel($data: ChannelInputType) {
    create_channel(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_CHANNEL = gql`
  mutation update_channel($data: UpdateChannelInputType) {
    update_channel(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const ADD_TEST_NUMBERS = gql`
  mutation add_test_numbers($data: AddTestNumbersInputType) {
    add_test_numbers(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const CREATE_COMPONENT = gql`
  mutation create_component($data: ComponentInputType) {
    create_component(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_COMPONENT = gql`
  mutation update_component($data: UpdateComponentInputType) {
    update_component(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const CREATE_SUGGESTION = gql`
  query create_prompt_suggestion($data: CreatePromptSuggestionInputType) {
    create_prompt_suggestion(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const DELETE_AGENT = gql`
  mutation delete_agent($data: DeleteAgentInputType) {
    delete_agent(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_SHARED_BOTS = gql`
  query get_shared_agents($data: GetSharedAgentsInputType) {
    get_shared_agents(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const ADD_SHARED_AGENT = gql`
  mutation shared_agent($data: SharedAgentsInputType) {
    shared_agent(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const EDIT_SHARED_AGENT = gql`
  mutation edit_shared_agent($data: EditSharedAgentInputType) {
    edit_shared_agent(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_PERSON = gql`
  query get_person($data: GetPersonInputType) {
    response: get_person(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const EDIT_PERSON = gql`
  mutation edit_person($data: EditPersonInputType) {
    edit_person(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const LIST_SHARED_AGENTS = gql`
  query list_shared_agents($data: ListSharedAgentsInputType) {
    list_shared_agents(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const REGISTER_INSTAGRAM_ACCOUNT = gql`
  mutation register_instagram_account(
    $data: RegisterInstagramAccountInputType
  ) {
    register_instagram_account(data: $data) {
      hasError
      data
      message
    }
  }
`;

